import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppHeaderComponent implements OnInit, OnDestroy {

    @HostBinding('class')
    get cssClasses() {
        return this.getCssClasses();
    }
    @HostBinding('attr.role') role = 'banner';

    @Input() isShrinkHeaderActive = false;

    isHeaderShrinked = false;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        public asService: UxAppShellService,
    ) {
    }

    ngOnInit() {
        this.asService.activateHeader();

        if (this.isShrinkHeaderActive) {
            fromEvent(window, 'scroll')
            .pipe(
                debounceTime(10),
                takeUntil(this.destroy$),
            )
            .subscribe(() => {
                const scrollPos = document.body.scrollTop || document.documentElement.scrollTop;

                if (scrollPos > 0) {
                    this.isHeaderShrinked = true;
                } else if (this.isHeaderShrinked && scrollPos < 1) {
                    this.isHeaderShrinked = false;
                }

                this.asService.setHeaderShrinkCssVar(this.isHeaderShrinked);
            });
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    private getCssClasses() {
        return [
            'eui-app-header',
            this.isHeaderShrinked ? 'eui-app-header--shrinked' : '',
        ].join(' ');
    }
}
